import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import configureStore from './store/configureStore';
import authActions from './actions/authActions';
import { load } from '@revenatium/vibranium-agencies/dist/reducers/accountCodeActions'

const parent = document.querySelector('.itm-agencies-form');
const store = configureStore();
store.dispatch(authActions.loadKey(process.env.REACT_APP_API_KEY));
if (parent.dataset) {
   store.dispatch(load(parent.dataset.account_code || null))
}

ReactDOM.render(
   <React.StrictMode>
      <Provider store={store}>
         <App parent={parent} />
      </Provider>
   </React.StrictMode>,
   parent
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
